import React from 'react';
import { Section } from './ui/Section';
import { Check, Clock } from 'lucide-react';
export function WhyChooseUs() {
  const reasons = ['Short turnaround time', 'Minimal documentation', 'Transparent pricing (no hidden charges)', 'Competitive interest rates', 'Face-to-face consultation', 'Regular follow-up & loan reviews', 'Proactive loan management', 'Personal one-to-one service'];
  return <Section bg="navy" data-id="element-544">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-545">
        <div data-id="element-546">
          <h2 className="text-gold font-bold tracking-wider text-sm uppercase mb-2" data-id="element-547">
            Why Choose Us
          </h2>
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-548">
            Your Financial Partner for Growth
          </h3>
          <p className="text-gray-300 mb-8 max-w-lg" data-id="element-549">
            We don't just offer loans; we offer a partnership built on trust,
            speed, and transparency. Experience the De Rien difference.
          </p>

          <div className="grid sm:grid-cols-2 gap-4" data-id="element-550">
            {reasons.map((reason, index) => <div key={index} className="flex items-start" data-id="element-551">
                <div className="flex-shrink-0 bg-gold/20 rounded-full p-1 mr-3 mt-1" data-id="element-552">
                  <Check className="h-3 w-3 text-gold" data-id="element-553" />
                </div>
                <span className="text-gray-200" data-id="element-554">{reason}</span>
              </div>)}
          </div>
        </div>

        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-555">
          <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-gold rounded-full blur-2xl opacity-20" data-id="element-556"></div>
          <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-32 h-32 bg-blue-500 rounded-full blur-2xl opacity-20" data-id="element-557"></div>

          <Clock className="h-16 w-16 text-gold mx-auto mb-6" data-id="element-558" />
          <h4 className="text-5xl font-bold text-white mb-2" data-id="element-559">24 Hours</h4>
          <p className="text-xl text-gold mb-6" data-id="element-560">Turnaround Time</p>
          <p className="text-gray-300" data-id="element-561">
            We commit to processing and approving loans within 24 hours. Speed
            and efficiency you can count on.
          </p>
        </div>
      </div>
    </Section>;
}